import type { FieldErrorDto } from "../../../../../autogen/bff-api";

// Mirrors MAX_EVENT_TITLE_LENGTH in the BFF's EventData.kt, which refuses a longer title on save.
export const MAX_EVENT_TITLE_LENGTH = 200;

export const titleLengthError = (title: string): FieldErrorDto | undefined =>
  title.length > MAX_EVENT_TITLE_LENGTH
    ? {
        field: "eventData.title",
        code: "zz_FieldErrorCode_TooLong",
        params: { max: String(MAX_EVENT_TITLE_LENGTH) },
      }
    : undefined;
